import { FC, useEffect, useMemo, useState } from 'react'
import { useTimerCore } from '@ucheba/utils/hooks/useTimerDate'
import { ITimerBannerProps } from '../types'
import TimerBannerNewYear from './TimerBannerNewYear'
import TimerBannerDefault from './TimerBannerDefault'
import TimerBannerBlackFriday from './TimerBannerBlackFriday'
import TimerBannerFixed from './TimerBannerFixed'

const TimerBanner: FC<ITimerBannerProps> = (props) => {
  const {
    date,
    title,
    onClick,
    type = 'default',
    color,
    buttonColor,
    buttonText,
    subTitle,
    discount,
    info,
    amoTag,
    classValue,
    prevTimeText,
  } = props
  const [show, setShow] = useState(false)
  const { seconds, hours, days, minutes } = useTimerCore(date)
  const isBlackFriday = useMemo(() => type === 'blackFriday', [type])
  const isNewYear = useMemo(() => type === 'newYear', [type])
  const isFixed = useMemo(() => type === 'fixed', [type])

  useEffect(() => {
    setShow(true)
  }, [])

  if (isNewYear) {
    return (
      <TimerBannerNewYear
        title={title}
        subTitle={subTitle}
        seconds={seconds}
        hours={hours}
        days={days}
        minutes={minutes}
        onClick={onClick}
        show={show}
        buttonText={buttonText}
        classValue={classValue}
      />
    )
  }

  if (isBlackFriday) {
    return (
      <TimerBannerBlackFriday
        title={title}
        subTitle={subTitle}
        seconds={seconds}
        hours={hours}
        days={days}
        minutes={minutes}
        onClick={onClick}
        show={show}
        buttonText={buttonText}
      />
    )
  }

  if (isFixed) {
    return (
      <TimerBannerFixed
        title={title}
        days={days}
        minutes={minutes}
        onClick={onClick}
        show={show}
        hours={hours}
        seconds={seconds}
        color={color}
        buttonColor={buttonColor}
        buttonText={buttonText}
        prevTimeText={prevTimeText}
      />
    )
  }

  return (
    <TimerBannerDefault
      title={title}
      days={days}
      minutes={minutes}
      onClick={onClick}
      show={show}
      hours={hours}
      seconds={seconds}
      color={color}
      buttonColor={buttonColor}
      buttonText={buttonText}
      subTitle={subTitle}
      discount={discount}
      text={info}
      amoTag={amoTag}
    />
  )
}

export default TimerBanner
